<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
	   
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
            <el-date-picker style="width:100%"
              v-model="query.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd" :unlink-panels="false" @change="query.ischange=true">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
              <el-select v-model="query.brandid" clearable remote  filterable placeholder="按品牌" @change="query.ischange=true">	            
                  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                      <span style="float: left">{{item.name}}</span>
                      <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                  </el-option>              
              </el-select>          
          </el-form-item>
          <el-form-item>
              <el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getList" @change="query.ischange=true"></el-input>
          </el-form-item>
          <el-form-item>
              <el-select v-model="query.ordertype" remote  filterable placeholder="排序类型" @change="query.ischange=true">	            
                  <el-option v-for="(item,index) in orderdertypelists" :label="item.name" :value="item.id" :key="index" />            
              </el-select>          
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search"  @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search"  @click="getbrandcost">品牌成本核算</el-button>
              <el-button type="primary" icon="el-icon-search"  @click="getcustomercost">客户成本核算</el-button>
              <el-button type="primary" icon="el-icon-search"  @click="getclerkcost">销售员成本核算</el-button>
          </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
          <el-table :data="loglists" :key="index" v-loading="query.loading">
              <el-table-column label="商品信息" min-width="250" fixed="left">
                  <template slot-scope="scope">
                      <div class="cost-log-averages">{{scope.row.name}}</div>
                      <div class="cost-log-averages-spec">ID：{{scope.row.id}}，规格：{{scope.row.spec}}，编码：{{scope.row.number}}</div>
                  </template>  
              </el-table-column>
              <el-table-column label="时间 - 类型" width="170" align="center" fixed="left">
                  <template slot-scope="scope">
                      <div class="cost-log-time">{{scope.row.time}}</div>
                      <div class="cost-log-type cost-log-type-in" v-if="scope.row.type==1">进货入库</div>
                      <div class="cost-log-type cost-log-type-out" v-if="scope.row.type==2">销售出库</div>
                      <div class="cost-log-type cost-log-type-in" v-if="scope.row.type==3">销售退货</div>
                      <div class="cost-log-type cost-log-type-out" v-if="scope.row.type==4">采购退货</div>
                      <div class="cost-log-type cost-log-type-out" v-if="scope.row.type==5">盘亏</div>
                      <div class="cost-log-type cost-log-type-in" v-if="scope.row.type==6">盘盈</div>
                      <div class="cost-log-type cost-log-type-in" v-if="scope.row.type==7">撤销完成销售单</div>
                      <div class="cost-log-type cost-log-type-out" v-if="scope.row.type==8">删除入库单</div>
                      <div class="cost-log-type cost-log-type-in" v-if="scope.row.type==9">采购退货撤销已完成</div>
                  </template>  
              </el-table-column>
              <el-table-column label="关联单号" width="150" align="center">
                  <template slot-scope="scope">
                      <div class="cost-log-time">{{scope.row.documents}}</div>
                  </template>  
              </el-table-column>
              <el-table-column label="期初结存" align="center">
                  <el-table-column label="单价" width="100" align="center">
                  <template slot-scope="scope">
                      <div class="cost-log-priceinfos">{{scope.row.startprice}}</div>
                  </template>  
                  </el-table-column>
                  <el-table-column label="数量" min-width="100" align="center">
                      <template slot-scope="scope">
                          <div class="cost-log-priceinfos">{{scope.row.startinventory}}</div>
                      </template>  
                  </el-table-column>
                  <el-table-column label="金额" min-width="100" align="center">
                      <template slot-scope="scope">
                          <div class="cost-log-priceinfos">{{scope.row.startcost}}</div>
                      </template>  
                  </el-table-column>  
              </el-table-column>
              <el-table-column label="本期收入" align="center">
                  <el-table-column label="单价" min-width="100" align="center">
                  <template slot-scope="scope">
                      <div class="cost-log-priceinfos">{{scope.row.inputpirce > 0 ? scope.row.inputpirce : '/'}}</div>
                  </template>  
                  </el-table-column>
                  <el-table-column label="数量" min-width="100" align="center">
                      <template slot-scope="scope">
                          <div class="cost-log-priceinfos">{{scope.row.inputinventory > 0 ? scope.row.inputinventory : '/'}}</div>
                      </template>  
                  </el-table-column>
                  <el-table-column label="金额" min-width="100" align="center">
                      <template slot-scope="scope">
                          <div class="cost-log-priceinfos">{{scope.row.inputcost > 0 ? scope.row.inputcost : '/'}}</div>
                      </template>  
                  </el-table-column>  
              </el-table-column>
              <el-table-column label="本期发出" align="center">
                  <el-table-column label="单价" min-width="100" align="center">
                  <template slot-scope="scope">
                      <div class="cost-log-priceinfos">{{scope.row.outpirce > 0 ? scope.row.outpirce : '/'}}</div>
                  </template>  
                  </el-table-column>
                  <el-table-column label="数量" min-width="100" align="center">
                      <template slot-scope="scope">
                          <div class="cost-log-priceinfos">{{scope.row.outinventory > 0 ? '-'+scope.row.outinventory : '/'}}</div>
                      </template>  
                  </el-table-column>
                  <el-table-column label="金额" min-width="100" align="center">
                      <template slot-scope="scope">
                          <div class="cost-log-priceinfos">{{scope.row.outcost > 0 ? '-'+scope.row.outcost : '/'}}</div>
                      </template>  
                  </el-table-column>  
              </el-table-column>
              <el-table-column label="期末结存" align="center">
                  <el-table-column label="单价" min-width="100" align="center">
                  <template slot-scope="scope">
                      <div class="cost-log-priceinfos">
                          {{scope.row.endprice}}
                          <span v-if="scope.row.endprice > scope.row.startprice">↑</span>
                          <span v-if="scope.row.endprice < scope.row.startprice">↓</span>
                      </div>
                  </template>  
                  </el-table-column>
                  <el-table-column label="数量" min-width="100" align="center">
                      <template slot-scope="scope">
                          <div class="cost-log-priceinfos">
                              {{scope.row.endinventory}}
                              <span v-if="scope.row.endinventory > scope.row.startinventory">↑</span>
                              <span v-if="scope.row.endinventory < scope.row.startinventory">↓</span>
                          </div>
                      </template>  
                  </el-table-column>
                  <el-table-column label="金额" min-width="100" align="center">
                      <template slot-scope="scope">
                          <div class="cost-log-priceinfos">
                              {{scope.row.endcost}}
                              <span v-if="scope.row.endcost > scope.row.startcost">↑</span>
                              <span v-if="scope.row.endcost < scope.row.startcost">↓</span>
                          </div>
                      </template>  
                  </el-table-column>  
              </el-table-column> 
          </el-table>
          <div class="block">      		
            <!--分页begin-->
            <el-pagination
	            @size-change="productPageSizeChange"
	            @current-change="productPageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="query.rows">
            </el-pagination>
            <!--分页end-->
      	  </div>
      </div>
       
  </div>
  </transition>  
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //功能权限
      url:this.GLOBAL.domain+"Cost/index",
      transitionshow:true,
      query: {
         act:'getlists',
         token:this.$cookies.get('token'),
         date:[],
         brandid:'',
         key:'',
         ordertype:2,
         loading:false,
         ischange:false,
         rows:0,
         p:1,
         rollpage:10
      },
      brandlists:[],
      orderdertypelists:[
          {id:1,name:'按写入记录时间倒序'},
          {id:2,name:'按写入记录时间升序'},
          {id:3,name:'按订单时间倒序'},
          {id:4,name:'按订单时间升序'},
      ],

      loglists:[],
      
    }
  },

  filters: {
    /** 价格信息保留两位小数 **/
    CFMprice(value) {
       var price=parseFloat(value); //修剪去小数点后多余的0
       var numsobj=price.toString().split(".");	//判断小数点后有几位小数
       var result=0.00;

       if(numsobj.length==1) result=price.toFixed(2); //值为0时补充到2位
       if(numsobj.length > 1 && numsobj[1].length <= 2) result=price.toFixed(2); //值为小数点后只有1位小数时补充到2位
       if(numsobj.length > 1 && numsobj[1].length > 2) result=price; //小数点后的值超出2位时直接返回
       return result;		
    }
  },

  mounted(){
    this.getactionauth();
    this.getBrand(); //获取品牌信息
    //this.getList();  //获取记录信息
    
  },
  methods:{

     /** 查看品牌成本核算 **/
     getbrandcost() {
         this.$emit('listenchild',{name:'品牌成本核算',url:'BrandCostAccount'});
     },

     /** 查看客户成本核算 **/
     getcustomercost() {
         this.$emit('listenchild',{name:'客户成本核算',url:'CustomerCostAccount'});
     },

     /** 查看销售员成本核算 **/
     getclerkcost() {
         this.$emit('listenchild',{name:'销售员成本核算',url:'ClerkCostAccount'});
     },


    /** 调整数字格式 **/
    changepriceformat(value) { 
        var price=parseFloat(value); //修剪去小数点后多余的0
        var numsobj=price.toString().split(".");	//判断小数点后有几位小数

        if(numsobj.length==1) return price.toFixed(2); //值为0时补充到2位
        if(numsobj.length > 1 && numsobj[1].length <= 2) return price.toFixed(2); //值为小数点后只有1位小数时补充到2位
        if(numsobj.length > 1 && numsobj[1].length > 2) return price; //小数点后的值超出2位时直接返回
    },  


    /** 获取成本记录信息 **/
    getList() {
        if(this.query.ischange) {
            this.query.p=1;
            this.query.rollpage=10;
        }

        this.query.loading=true;
        var resource = this.$resource(this.url);
            resource.save(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading=false;
            }else{
                this.loglists = JSON.parse(Base64.decode(res.data.Data));
                this.query.rows=parseInt(res.data.count);
                this.query.loading=false;
                if(this.query.ischange) this.query.ischange=false;

                var _this=this;
                this.loglists.forEach(function(e,index) {
                    e.startprice=_this.changepriceformat(e.startprice);
                    e.startcost=_this.changepriceformat(e.startcost);
                    e.inputpirce=_this.changepriceformat(e.inputpirce);
                    e.inputcost=_this.changepriceformat(e.inputcost);
                    e.outpirce=_this.changepriceformat(e.outpirce);
                    e.outcost=_this.changepriceformat(e.outcost);
                    e.endprice=_this.changepriceformat(e.endprice);
                    e.endcost=_this.changepriceformat(e.endcost);

                    e.startinventory=Number(e.startinventory);
                    e.endinventory=Number(e.endinventory);
                });

            }
        }).catch((res) => {
            this.query.loading=false;
        });

    },

    productPageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    productPageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },

    
    /** 获取功能操作权限 **/
    getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
        resource.save({act:'lists',token:this.$cookies.get('token'),jdshow:0,rollpage:100000}).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
        }else{
            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 0 1%;}
.cost-log-averages {float:left;width:100%;font-size:13px;line-height:23px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.cost-log-averages-spec {float:left;font-size:12px;line-height:23px;color:#999999}
.cost-log-time {font-size:13px;line-height:23px;float:left;width:100%}
.cost-log-type {font-size:12px;line-height:21px;padding:1px 10px;border-radius:15px;margin:0 auto;margin-top:5px;}
.cost-log-type-in {background:#67c23a;color:#fff;display:inline-block;}
.cost-log-type-out {background:#f78989;color:#fff;display:inline-block;}
.cost-log-priceinfos {font-size:13px;line-height:23px}
.cost-log-gray {background:#909399}
</style>


// WEBPACK FOOTER //
// src/components/inventory/CostAccount.vue